import { createHttpClient } from "./httpClientFactory";
import { portalTokenStore } from "./tokenStore";

export const portalApi = createHttpClient({
  refreshPath: "/portal/auth/refresh",
  tokenStore: portalTokenStore,
});
